"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAMES_CHAINS = exports.TON_CHAINS = exports.COSMOS_CHAINS = exports.APTOS_CHAINS = exports.SUI_CHAINS = exports.SOLANA_CHAINS = exports.BTC_CHAINS = void 0;
const misc_1 = require("./misc");
exports.BTC_CHAINS = {
    MAINNET: 'btc:mainnet',
    FRACTAL: 'fractal:mainnet',
};
exports.SOLANA_CHAINS = {
    MAINNET: 'solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp',
    TESTNET: 'solana:4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z',
    SONIC_TESTNET: 'sonic:4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z'
};
exports.SUI_CHAINS = {
    MAINNET: 'sui:mainnet'
};
exports.APTOS_CHAINS = {
    MAINNET: 'aptos:mainnet', // aptos mainnet
    MOVEMENT_MAINNET: 'movement:mainnet',
    MOVEMENT_TESTNET: 'movement:testnet',
};
exports.COSMOS_CHAINS = {
    COSMOS_MAINNET: 'cosmos:cosmoshub-4'
};
exports.TON_CHAINS = {
    MAINNET: 'ton:-239', // mainnet
};
exports.NAMES_CHAINS = {
    [misc_1.NameSpaceKeyBtc]: Object.values(exports.BTC_CHAINS),
    [misc_1.NameSpaceKeySOL]: Object.values(exports.SOLANA_CHAINS),
    [misc_1.NameSpaceKeyTON]: Object.values(exports.TON_CHAINS),
    [misc_1.NameSpaceKeySui]: Object.values(exports.SUI_CHAINS),
    [misc_1.NameSpaceKeyAptos]: Object.values(exports.APTOS_CHAINS),
    [misc_1.NameSpaceKeyCosmos]: Object.values(exports.COSMOS_CHAINS)
};
